interface Props {
  title: string;
  price: string;
  duration?: string;
  description?: string;
  ctaLabel?: string;
  ctaHref?: string;
}

export function PriceCard({ title, price, duration, description, ctaLabel = "Réserver", ctaHref = "/contact" }: Props) {
  return (
    <div
      className="group flex flex-col justify-between rounded-2xl border p-7 transition-all hover:border-sage hover:shadow-sm"
      style={{ backgroundColor: "var(--color-background)", borderColor: "var(--color-border)" }}
    >
      <div>
        <div className="flex items-baseline justify-between gap-4">
          <h3 className="font-display text-2xl font-normal leading-tight">{title}</h3>
          <span className="font-display text-2xl whitespace-nowrap" style={{ color: "var(--color-sage-text)" }}>
            {price}
          </span>
        </div>
        {duration && (
          <p className="mt-2 text-xs uppercase tracking-[0.18em]" style={{ color: "var(--color-muted-foreground)" }}>
            {duration}
          </p>
        )}
        {description && (
          <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--color-text)" }}>
            {description}
          </p>
        )}
      </div>
      <a
        href={ctaHref}
        className="mt-6 inline-flex items-center text-sm font-medium transition-colors"
        style={{ color: "var(--color-dark)" }}
      >
        <span className="border-b border-current pb-0.5">{ctaLabel}</span>
        <span className="ml-2 transition-transform group-hover:translate-x-1">→</span>
      </a>
    </div>
  );
}
